import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { IInspectionData, ITableColumn } from "./InspectionInterface";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { environment } from "src/environments/environment";
import { AdminService } from "../admin.service";
import { ToastrService } from "ngx-toastr";
import { LoaderService } from "src/app/utils/loader.service";

@Component({
  selector: "app-inspection",
  templateUrl: "./inspection.component.html",
  styleUrls: ["./inspection.component.scss"],
})
export class InspectionComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  pageLoad: boolean = true;
  tabIndex: number = 0;
  dataSource: MatTableDataSource<any>;

  total_count: number = 0;
  page_count: number = 1;
  pageIndex = 0;
  pageSize = 10;
  pageSizeOptions = [10, 25, 50, 100];

  columnData: ITableColumn[] = [
    {
      bShow: true,
      key: "order_code",
      viewValue: "Order",
      type: "number",
      classKey: "order_code",
      classValue: "fw-bold",
    },
    {
      bShow: true,
      key: "round",
      viewValue: "Round",
      type: "number",
      classKey: "round",
      classValue: "fw-bold",
    },
    {
      bShow: true,
      key: "docs",
      viewValue: "Parts",
      type: "text",
      classKey: "docs",
      classValue: "fw-bold",
    },
    {
      bShow: true,
      key: "inspectionStatus",
      viewValue: "Inspection Status",
      type: "text",
      classKey: "inspectionStatus",
      classValue: "fw-bold",
    },
    {
      bShow: true,
      key: "inspectionTime",
      viewValue: "Scheduled Date",
      type: "date",
    },
    {
      bShow: true,
      key: "inspectionParticipants",
      viewValue: "Participants",
      type: "text",
      avatar: { bShow: true, columnKey: "inspectionParticipants" },
    },
    {
      bShow: true,
      key: "inspectionScheduler",
      viewValue: "Scheduled By",
      type: "text",
      avatar: { bShow: true, columnKey: "inspectionScheduler" },
    },
  ];

  inspectionData: IInspectionData[] = [];

  columnsDefs: Array<any>;
  displayedColumns: Array<any>;
  actionColumn = {
    header: "Action",
    key: "action",
    bShow: true,
    class: "link",
    title: "Join Session",
    toolTip: "Click to join meeting",
    pastActions: [
      {
        title: "Download Report",
        toolTip: "Click to download report",
        disabled: true //:Make this false when you have figured out a way to download the report from JSON object
      },
      {
        title: "Session Summary",
        toolTip: "Click to view session summary",
        disabled: true //:Make this false when jitsi in implemented
      }
    ],
    futureActions: [
      {
        title: "Join Session",
        toolTip: "Click to join meeting",
        disabled: false
      },
    ],
  };

  constructor(
    private adminService: AdminService,
    private toaster: ToastrService,
    private loaderService: LoaderService
  ) {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.getAllInspectionsRecords();
    this.pageLoad = false;
    this.dataSource.data = [];
    this.displayedColumns = this.columnData.filter((ob) => ob.bShow);
    this.columnsDefs = this.columnData
      .filter((ob) => ob.bShow)
      .map((ob) => ob.key);
    this.columnsDefs = this.columnsDefs.concat([this.actionColumn.key]);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    // Set up the filter predicate
    this.dataSource.filterPredicate = (data, filter: string): boolean => {
      const searchString = filter.trim().toLowerCase();
      return Object.values(data).some(value =>
        String(value).toLowerCase().includes(searchString)
      );
    };
  }

  getAllInspectionsRecords() {
    this.loaderService.display(true);
    this.adminService.getAllInspectionDetails((this.page_count).toString(), this.pageSize.toString()).subscribe((res: any) => {
      const headers = res.headers;
      this.inspectionData = res?.body;
      this.dataSource.data = this.inspectionData;
      const unfilteredCount = Number(headers.get('x-total'));
      this.paginator.length = this.total_count = unfilteredCount ? unfilteredCount : this.inspectionData.length;
      this.loaderService.display(false);
    },
      error => {
        this.loaderService.display(false);
      });
  }

  isInspectionYetToHappen(element: any): boolean {
    const inspectionScheduleData = element?.inspectionDate
    const currentDate = new Date();
    const inputDate = new Date(inspectionScheduleData);
    return inputDate > currentDate || element['inspectionStatus'].some(batch => batch?.inspectionStatus === 'Scheduled' || batch?.inspectionStatus === 'Incomplete');
  }

  onTabChange(event) {
    this.tabIndex = event.index;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  futureActionCellClick(element: any) {
    console.log(element, "JOIN MEETING");
    let meeting_id = element?.docs[0]?.meetingLink;
    const meeting_id_split = meeting_id?.split("/")
    meeting_id = meeting_id_split[meeting_id_split.length - 1]
    const session_id = element?.session_id;
    if (!meeting_id) {
      return this.toaster.error("Meeting link is invalid.", "Error")
    }
    window.open(
      environment.safeUrl +
      `dashboard/inspection-session/?id=${meeting_id}&session_id=${session_id}&token=` +
      localStorage.getItem("token"),
      "_blank"
    );
  }

  pastActionCellClick(element: any) {
    console.log(element);
  }

  paginationChange(event: any) {
    console.log(event);
    this.pageSize = event.pageSize;
    if (event?.previousPageIndex > event.pageIndex) {
      this.page_count = this.page_count - 1;
      // this.getAllInspectionsRecords().then((result) => {
      //   this.paginator.length = event.length = this.total_count;
      // });
      this.getAllInspectionsRecords();
    } else if (event?.previousPageIndex < event.pageIndex) {
      // this.paginator.length = event.length = this.total_count;
      this.page_count += 1;
      // this.getAllBids().then((result) => {
      //   this.paginator.length = event.length = this.total_count;
      // });
      this.getAllInspectionsRecords();
    } else {
      // this.getAllBids().then((result) => {
      //   this.paginator.length = event.length = this.total_count;
      // });
      this.getAllInspectionsRecords();
    }
  }
}
